module.exports = __webpack_public_path__ + "assets/img/gift-4-25fa8697.png";